module.exports = __webpack_public_path__ + "img/AAU_Logo.6c58fa78.jpg";